<template>
	<v-card>
		<v-card-title> Actualizar canales </v-card-title>

		<v-card-text>
			<v-file-input
				accept=".xlsx, .xls"
				v-model="fileToUpload"
				truncate-length="15"
				:disabled="isLoading"
			></v-file-input>

			<v-btn
				class="primary"
				:disabled="!fileToUpload || (fileToUpload && isLoading)"
				:loading="fileToUpload && isLoading"
				@click="uploadChannel"
			>
				Cargar
			</v-btn>
		</v-card-text>
	</v-card>
</template>

<script>
	/* Formulario para procesar excel con los datos de los canales */
	import { mapActions, mapState } from 'vuex';

	export default {
		name: 'irrigator-channel-form-add',

		data() {
			return {
				fileToUpload: null,
				loading: false,
			};
		},

		computed: {
			...mapState({
				isLoading: state => state.systemNotification.isLoading,
			}),
		},

		methods: {
			...mapActions('filesControl', ['uploadChannelData']),

			uploadChannel() {
				this.loading = true;

				if (this.fileToUpload)
					this.uploadChannelData(this.fileToUpload).finally(() => {
						this.loading = false;
						this.fileToUpload = null;
					});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.add-irrigator {
		position: absolute;
		bottom: 10px;
		right: 10px;
	}
</style>
